import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ContractorService from "./ContractorService";

const initialState = {
    contractors: null,
    contractor: null,
    isSuccess: false,
    isLoading: false,
    isError: false,
    errors: false,
    message: null,
}

export const GetAllContractors = createAsyncThunk(
    "contractors/index", async (_, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await ContractorService.GetAllContractors(token);
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data?.error);
        }
    }
)

export const SearchONContractors = createAsyncThunk(
    "contractors/search", async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await ContractorService.SearchONContractors(data, token);
        } catch (error) {
            let message = error.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
)

export const CreateNewContractor = createAsyncThunk(
    "contractor/create", async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await ContractorService.CreateNewContractor(data, token);
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data?.error);
        }
    }
)

export const GetSingleContractor = createAsyncThunk(
    "contractor/show", async (id, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await ContractorService.GetSingleContractor(id, token);
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data?.error);
        }
    }
)

export const UpdateContractorData = createAsyncThunk(
    "contractor/update", async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await ContractorService.UpdateContractorData(data, token);
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data?.error);
        }
    }
)

export const DeleteContractorAction = createAsyncThunk(
    "contractor/delete", async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await ContractorService.DeleteContractorAction(data, token);
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data?.error);
        }
    }
)

const ContractorSlice = createSlice({
    name: "contractors",
    initialState,
    reducers: {
        contractorsReset: (state) => {
            state.isSuccess = false;
            state.isLoading = false;
            state.isError = false;
            state.errors = false;
            state.message = null;
        }
    },
    extraReducers: {
        [GetAllContractors.pending]: (state) => {
            state.isLoading = true;
        },
        [GetAllContractors.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.contractors = action.payload;
        },
        [GetAllContractors.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.message = action.payload;
            state.errors = action.payload;
        },

        // Search On Contractors 
        [SearchONContractors.pending]: (state) => {
            state.isLoading = true;
        },
        [SearchONContractors.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.contractors = action.payload;
            state.isSuccess = true;
        },
        [SearchONContractors.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.message = action.payload;
        },

        // SHOW Contractor
        [GetSingleContractor.pending]: (state) => {
            state.isLoading = true;
        },
        [GetSingleContractor.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false
            state.contractor = action.payload
        },
        [GetSingleContractor.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
        },

        // Create New Contractor
        [CreateNewContractor.pending]: (state) => {
            state.isLoading = true;
        },
        [CreateNewContractor.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
        },
        [CreateNewContractor.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errors = action.payload
        },

        // Update Contractor Data
        [UpdateContractorData.pending]: (state) => {
            state.isLoading = true;
        },
        [UpdateContractorData.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
        },
        [UpdateContractorData.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errors = action.payload
        },

        // Delete Contractor Data
        [DeleteContractorAction.pending]: (state) => {
            state.isLoading = true;
        },
        [DeleteContractorAction.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
        },
        [DeleteContractorAction.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errors = action.payload
        },
    }
})

export const { contractorsReset } = ContractorSlice.actions

export default ContractorSlice.reducer